// extracted by mini-css-extract-plugin
export default {"screen":"MainScreen_screen__AF+tw","list":"MainScreen_list__6s+xr","details":"MainScreen_details__EoAKI","preview":"MainScreen_preview__Hblib","actions":"MainScreen_actions__ldOYZ"};